import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { BUSINESS_CHALLENGES, topicFor } from '@/data/insights';
import { Reveal } from '../Reveal';

// Section 7 — Browse by business challenge. SEO-supporting internal
// navigation: each challenge deep-links to a filtered collection on this
// page (?topic=...). Future dedicated topic landing routes (e.g.
// /insights/operations) go live only with unique copy and real depth.
export const ChallengeNav = () => (
  <section aria-labelledby="challenges-heading" data-testid="insights-challenges" className="bg-mist py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="flex items-center gap-3">
          <span className="font-mono text-xs font-medium tracking-widest text-gold-700">05</span>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">Challenges</span>
        </p>
        <h2 id="challenges-heading" data-testid="challenges-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
          What would you like to improve?
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
          Find practical insights based on the challenge your business is facing.
        </p>
      </div>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="challenges-grid">
        {BUSINESS_CHALLENGES.map((c, i) => {
          const topic = topicFor(c.topic);
          return (
            <Reveal key={c.label} delay={(i % 3) * 0.06} className="h-full">
              <Link
                to={`/insights?topic=${c.topic}#latest-insights`}
                data-testid={`challenge-${c.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                className="group flex h-full items-center justify-between gap-4 rounded-lg border border-slate-200 bg-white px-5 py-4 transition-[border-color,box-shadow] duration-200 hover:border-navy-300 hover:shadow-card"
                style={topic ? { borderLeftWidth: '3px', borderLeftColor: topic.color } : undefined}
              >
                <span className="text-sm font-bold text-navy-900">{c.label}</span>
                <ArrowRight className="h-4 w-4 shrink-0 text-slate-300 transition-all duration-200 group-hover:translate-x-1 group-hover:text-navy-900" aria-hidden="true" />
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
